import { useLocalization } from '@/shared/composables/localization'
import { isPServedIsUser, fromPServedUser } from '@/shared/utils/uri'

export {
  BOT_CONTROL_P_SERVED,
  findMatchingSystemBotContacts,
  getSystemBotContact,
  matchesSystemBotContactSearch,
  matchesSystemBotPServedQuery,
  matchesSystemBotSearch,
  mergeSystemBotSearchResults,
  systemBotToContact,
} from './system-bots'

export const getUnknownContactLabel = (pServed: string) => {
  const { t } = useLocalization()

  if (isPServedIsUser(pServed)) {
    return `${t('common.subscriber')} ${fromPServedUser(pServed)}`
  }

  return t('common.externalContact')
}
